import { createStore, createHook, type Action } from '@atlassian/react-sweet-state';
import type { StoreState, ProactiveDescriptionCompleterPayload } from './types.tsx';

const initialState: StoreState = {
	proactiveDescriptionCompleterPayload: undefined,
};
const actions = {
	getProactiveDescriptionCompleterPayload:
		(): Action<StoreState, void, ProactiveDescriptionCompleterPayload | undefined> =>
		({ getState }) => {
			// Access the current state and return the value of proactiveDescriptionCompleterPayload
			return getState().proactiveDescriptionCompleterPayload;
		},
	setProactiveDescriptionCompleterPayload:
		(
			proactiveDescriptionCompleterPayload: ProactiveDescriptionCompleterPayload,
		): Action<StoreState> =>
		({ setState }) => {
			setState({ proactiveDescriptionCompleterPayload });
		},
	resetProactiveDescriptionCompleterPayload:
		(): Action<StoreState> =>
		({ setState }) => {
			setState({ proactiveDescriptionCompleterPayload: undefined });
		},
};
const ProactiveDescriptionCompleterStore = createStore<StoreState, typeof actions>({
	initialState,
	actions,
});
export const useProactiveDescriptionCompleterStore = createHook(ProactiveDescriptionCompleterStore);
